{
  "Özlük": "Personal Details",
  "ozluk": {
    "Personel Tanımınız Yok": "No Personnel Definition",
    "Özlük": "Personal Details",
    "Güncelleme başarılı": "Güncelleme başarılı"
  }
}
